import BaseModelRequest from '../communicate/BaseModelRequest'
import {getToken} from '../services/authService'

export default class FlashSaleRequest extends BaseModelRequest {

  builderHeader () {
    const headers = super.builderHeader();
    headers.Authorization = 'Bearer ' + getToken();
    return headers;
  }

  getFlashSales() {
    const url = "flash_sales";
    return this.get(url);
  }

  flashSale(payment_method) {
    const url = "flash_sale/payment";
    return this.post(url, {payment_method: payment_method});
  }
}



// WEBPACK FOOTER //
// ./src/request/FlashSaleRequest.js